export class Index {
    public constructor() {
        let $sortBy = $("#sort-by");

        if (!$sortBy.length) {
            return;
        }

        $sortBy.on("change", Index.onChangeSort)
    }

    private static onChangeSort(e: Event) {
        e.preventDefault();
        e.stopPropagation();

        let val = $("#sort").val();

        if (val === undefined) {
            return
        }

        let querySeparator = "?";

        if (window.location.href.includes("sort=skill")) {
            window.location.href = window.location.href.replace("sort=skill", "sort=" + val.toString());

            return
        }

        if (window.location.href.includes("sort=peak_skill")) {
            console.log(window.location.href.replace("peak_skill", val.toString()));

            window.location.href = window.location.href.replace("sort=peak_skill", "sort=" + val.toString());

            return
        }

        if (window.location.href.includes("?")) {
            querySeparator = "&"
        }

        window.location.href = window.location.href + querySeparator + "sort=" + val.toString();
    }
}